import { combineReducers } from "redux";

import userdetails from "./UserDetailsReducer";
import envdata from "./EnvDataReducer";
import extid from "./ExtIdReducer";
import participants from "./ParticipantsReducer";
import B2CSettings from "./B2CSettingsReducer";
import srarnsIndividual from "./SRARNsIndividualReducer";
import srarnsOrganisation from "./SRARNsOrganisationReducer";
import draftsIndividual from "./DraftsIndividualReducer";
import draftsOrganisation from "./DraftsOrganisationReducer";
import draftFormsIndividual from "./DraftFormsIndividualReducer";
import appsIndividual from "./AppsIndividualReducer";
import appsOrganisation from "./AppsOrganisationReducer";
import SPFileDetails from "./SPFileDetailsReducer";
import DeRegisterDrone from "./DeRegisterDroneReducer";
import DownloadCommAccredApple from './DownloadCommAccredAppleReducer';
import DownloadRecAccredApple from './DownloadRecAccredAppleReducer';
import DownloadCommAccredGoogle from './DownloadCommAccredGoogleReducer';
import DownloadRecAccredGoogle from './DownloadRecAccredGoogleReducer';

import DownloadReplApple from './DownloadRePLAppleReducer';
import DownloadReplGoogle from './DownloadRePLGoogleReducer';
import DownloadFCLApple from './DownloadFCLAppleReducer';
import DownloadFCLGoogle from './DownloadFCLGoogleReducer';
import DownloadAROCApple from './DownloadAROCAppleReducer';
import DownloadAROCGoogle from './DownloadAROCGoogleReducer';
import FlightCrewIndividualPicture from './FlightCrewIndividualPictureReducer';
import FlightCrewComponents from './FlightCrewComponentsReducer';
import FlightCrewRatings from './FlightCrewRatingsReducer';
import FlightCrewOperationalRatings from './FlightCrewOperationalRatingsReducer';
import FlightCrewTheoryExaminations from './FlightCrewTheoryExaminationsReducer';

import AROCDetails from './AROCDetailsReducer';

import licencesIndividual from "./LicencesIndividualReducer";
import alertsIndividual from "./AlertsIndividualReducer"; 
import alertsOrganisation from "./AlertsOrganisationReducer"; 
import alertsAircraft from "./AlertsAircraftReducer"; 
import certificatesIndividual from "./CertificatesIndividualReducer"; 
import certificatesOrganisation from "./CertificatesOrganisationReducer"; 
import dronesIndividual from "./DronesIndividualReducer"; 
import dronesOrganisation from "./DronesOrganisationReducer"; 
import droneSubmissions from "./DroneSubmissionsReducer"; 
import REOCsIndividual from "./REOCsIndividualReducer"; 
import REOCsOrganisation from "./REOCsOrganisationReducer"; 

import REPLsIndividual from "./REPLsIndividualReducer"; 
import tagsIndividual from "./TagsIndividualReducer"; 
import acceptedSRsIndividual from "./AcceptedSRsIndividualReducer";
import aircraftIndividual from "./AircraftIndividualReducer"; 
import aircraftOrganisation from "./AircraftOrganisationReducer"; 
import aircraftTOOIndividual from "./AircraftTOOIndividualReducer"; 
import examinations from "./ExaminationsReducer"; 

import addressdetailsIndividual from "./AddressDetailsIndividualReducer"; 
import addressdetailsOrganisation from "./AddressDetailsOrganisationReducer"; 

import certificatesProfile from "./CertificatesProfileReducer";
import dronesProfile from "./DronesProfileReducer";

import organisationDetails from "./OrganisationDetailsReducer"; 
import organisationUsers from "./OrganisationUsersReducer"; 

import getOrganisation from "./Organisation/GetOrganisatioNDetailsCrm"

import pageAlert from "./PageAlertReducer"; 

import ratecards from "./RateCardsReducer";

import formStore from '../../FormStore/Reducers/RootFormStoreReducer';
import crmReferenceData from '../../FormStore/Reducers/CRMReferenceDataReducer';

export default combineReducers({
    //portal
    userdetails,
    getOrganisation,
    envdata,
    extid,
    participants,
    B2CSettings,
    srarnsIndividual,
    srarnsOrganisation,
    draftsIndividual,
    draftsOrganisation,
    draftFormsIndividual,
    appsIndividual,
    appsOrganisation,
    licencesIndividual,
    alertsIndividual,
    alertsOrganisation,
    alertsAircraft,
    certificatesIndividual,
    certificatesOrganisation,
    dronesIndividual,
    dronesOrganisation,
    droneSubmissions,
    tagsIndividual,
    acceptedSRsIndividual,
    aircraftIndividual,
    aircraftOrganisation,
    aircraftTOOIndividual,
    REOCsIndividual,
    REOCsOrganisation,
    REPLsIndividual,
    addressdetailsIndividual,
    addressdetailsOrganisation,
    examinations,

    FlightCrewIndividualPicture,
    FlightCrewComponents,
    FlightCrewRatings,
    FlightCrewOperationalRatings,
    FlightCrewTheoryExaminations,

    AROCDetails,

    certificatesProfile,
    dronesProfile,

    organisationDetails,
    organisationUsers,

    SPFileDetails,
    DeRegisterDrone,
    DownloadReplApple,
    DownloadReplGoogle,
    DownloadFCLApple,
    DownloadFCLGoogle,
    DownloadAROCApple,
    DownloadAROCGoogle,
    DownloadCommAccredApple,
    DownloadRecAccredApple,
    DownloadCommAccredGoogle,
    DownloadRecAccredGoogle,

    pageAlert,

    ratecards,

    //form
    formStore,
    crmReferenceData,

});